import TransactionDetailsContainer from './transactionDetailsContainer'

export default TransactionDetailsContainer